export const constants = {
  ROLE_ADMIN: 'ADMIN',
  ROLE_MANAGER: 'MANAGER',
  ROLE_OPER: 'OPER',
  ROLE_MES: 'MES',
  ROLE_TRANSFER: 'TRANSFER',
  ROLE_QUALITY: 'QUALITY',
  ROLE_RICEZIONE: 'RECEPTION',
  ROLE_SPE: 'SHIPPING',
  ROLE_EXTWORK: 'EXTWORK',
  ROLE_INV: 'INVENTORY',
  ROLE_ANA: 'REGISTRY',
  ROLE_ART: 'ARTICLE',
  ROLE_ODV: 'ODV',
  ROLE_PLANNING: 'PLANNING',
  // Feature 159: chat AI (creato a mano in sviluppo, stage e prod).
  ROLE_CHAT: 'CHAT',
  // Feature 164: in più ad ADMIN, modifica il contesto generale della chat AI (ruolo creato a mano).
  ROLE_SUPERADMIN: 'SUPERADMIN',
  MOD_ANA_BASE_UI: 'ANA-BASE-UI',
  MOD_ART_BASE_UI: 'ART-BASE-UI',
  MOD_ODV_BASE_UI: 'ODV-BASE-UI',
  MOD_PLA_BASE_UI: 'PLA-BASE-UI',
  MOD_PRO_BASE: 'PRO-BASE',
  MOD_PRO_BASE_UI: 'PRO-BASE-UI',
  MOD_PRO_BASE_MAN: 'PRO-BASE-MAN',
  MOD_PRO_BASE_GROUP: 'PRO-BASE-GROUP',
  MOD_PRO_BASE_COLUMN: 'PRO-BASE-COLUMN',
  MOD_PRO_BASE_STA: 'PRO-BASE-STA',
  MOD_PRO_BASE_AVM_PLAN: 'PRO-BASE-AVM-PLAN',
  MOD_PRO_BASE_LOTTI: 'PRO-BASE-LOTTI',
  MOD_PRO_BASE_BARCODE: 'PRO-BASE-BARCODE',
  MOD_PRO_BASE_TRANSFER: 'PRO-BASE-TRANSFER',
  MOD_PRO_BASE_ATTACHMENT: 'PRO-BASE-ATTACHMENT',
  MOD_PRO_BASE_BALANCE: 'PRO-BASE-BALANCE',
  MOD_PRO_BASE_BOX: 'PRO-BASE-BOX',
  MOD_PRO_BASE_PRINTER: 'PRO-BASE-PRINTER',
  MOD_PRO_BASE_INV: 'PRO-BASE-INV',
  MOD_PRO_BASE_WMS: 'PRO-BASE-WMS',
  MOD_PRO_BASE_IMPORT: 'PRO-BASE-IMPORT',
  MOD_PRO_BASE_EXPORT: 'PRO-BASE-EXPORT',
  MOD_PRO_BASE_STORIA: 'PRO-BASE-STORIA',
  MOD_QUA_BASE_UI: 'QUA-BASE-UI',
  MOD_RIC_BASE_UI: 'RIC-BASE-UI',
  MOD_SPE_BASE_MAN: 'SPE-BASE-MAN',
  MOD_SPE_BASE_WMS: 'SPE-BASE-WMS',
  MOD_TER_BASE_UI: 'TER-BASE-UI',
  MOD_TER_BASE_ACQ: 'TER-BASE-ACQ',
  MOD_TER_BASE_PRO: 'TER-BASE-PRO',
  MOD_ATH_BASE: 'ATH-BASE',
  MOD_ATH_BASE_BADGE: 'ATH-BASE-BADGE',
  MOD_AI_BASE_CHAT: 'AI-BASE-CHAT',
  DDTACQ: 'DDTACQ',
  DDTMES: 'DDTMES',
  DDTMESL: 'DDTMESL',
  DDTMESLR: 'DDTMESLR',
  FACTOR: 1000000
};
